import React from "react";
import SEO from "../components/SEO";
import { Link } from "react-router-dom";

const About = () => (
  <>
    <SEO title="About" description="The story behind The Dripchexk — premium streetwear from India for the ones building a legacy." />
    <section className="relative bg-[#0a0a0a] border-b border-[#222] py-24 grain overflow-hidden">
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <p className="tiny-link text-[#FF69B4]">About</p>
        <h1 className="font-display text-5xl sm:text-7xl mt-3 tracking-[0.03em]">
          THE DRIP IS REAL<span className="text-[#FF69B4]">.</span>
        </h1>
      </div>
    </section>
    <section className="max-w-3xl mx-auto px-6 py-20 space-y-8 text-white/80 leading-relaxed">
      <p className="text-lg">
        The Dripchexk is a premium streetwear label out of India, made for the generation that doesn't ask permission.
      </p>
      <p>
        We build heavyweight oversized hoodies and tees that wear like armor and read like a diary — quiet luxury, loud statements. Each drop is small, intentional, and finished by hand.
      </p>
      <p>
        From the Porsche dreams to the don't-tell-mama nights, every piece is a chapter. Wear it with the people you love and the trouble you choose.
      </p>
      <div className="border border-[#222] p-6 mt-10">
        <p className="tiny-link text-white/40">Reach the founders</p>
        <p className="mt-3 text-sm">
          thedripchexk@gmail.com · WhatsApp +91 8383862206 · Instagram{" "}
          <a
            className="underline hover:text-[#FF69B4] transition-colors"
            target="_blank"
            rel="noreferrer"
            href="https://instagram.com/thedripchexk"
          >
            @thedripchexk
          </a>
        </p>
      </div>
      <Link
        to="/collections"
        className="pink-cta tiny-link inline-block px-8 py-4 mt-4"
        data-testid="about-shop-cta"
      >
        Shop the Drop →
      </Link>
    </section>
  </>
);
export default About;
